import { forwardRef, memo } from 'react';

import { useTranslation } from '@lyearn/i18n';
import { Search as SearchIcon } from '@lyearn/icons';
import { cn } from '@lyearn/style';
import { Input } from '@lyearn/ui';

import { SearchBarProps } from './types';

const SearchInput = forwardRef<
  HTMLInputElement,
  SearchBarProps & { endAdornment?: React.ReactNode }
>((props, ref) => {
  const { t } = useTranslation();
  const {
    autoFocus,
    className,
    startAdornment = (
      <SearchIcon className="h-24 w-24 flex-shrink-0 fill-current text-icon-placeholder xs:text-icon-secondary" />
    ),
    endAdornment,
    placeholder = t('Common:Search'),
    value,
    size = 'large',
    shape = 'pill',
    variant,
    onChange,
    appearance,
  } = props;

  return (
    <Input
      ref={ref}
      appearance={appearance}
      autoFocus={autoFocus}
      className={cn('w-full flex-grow me-8', className)}
      endAdornment={endAdornment}
      placeholder={placeholder}
      shape={shape}
      size={size}
      startAdornment={startAdornment}
      value={value}
      variant={variant}
      onChangeText={onChange}
    />
  );
});

export default memo(SearchInput);
